import { VolumeCurveConfiguration } from './configuration/VolumeCurveConfiguration';
import { WidgetWithConfigState } from 'widgets/store/configuration/WidgetWithConfigState';
import { WidgetWithComponentState } from 'widgets/store/component/WidgetWithComponentState.ts';
import { VolumeCurveComponentState } from 'widgets/volumeCurve/store/component/VolumeCurveComponentState.ts';

export type VolumeCurveWidgetState =
    WidgetWithConfigState<VolumeCurveConfiguration> &
        WidgetWithComponentState<VolumeCurveComponentState>;

export interface VolumeCurveWidgetsState {
    [widgetId: string]: VolumeCurveWidgetState;
}

export const initialVolumeCurveWidgetsState: VolumeCurveWidgetsState = {};
